import { FieldConfig } from '../../api/contract-notice-dto';

export function findRowIndexByUuid(dataArray: any[], rowUuid: string): number {
  return dataArray.findIndex((item: any) => item.rowUuid === rowUuid);
}

export function removeRowFromData(dataArray: any[], index: number): void {
  dataArray.splice(index, 1);
}

export function getValues(formService: any, object: any, property: string): any {
  return formService.getNestedProperty(object, property);
}

export function ensureArray(value: any): any[] {
  return Array.isArray(value) ? value : [value];
}

export function updatePreviousValues(
  previousValues: Map<string, any>,
  property: string,
  value: any
): void {
  previousValues.set(property, value);
}

export function checkValueInArray(
  array: any[],
  value: any,
  isEqualValue: (a: any, b: any) => boolean
): boolean {
  return array.some(item => isEqualValue(item, value));
}

export function processEvalExpression(
  evalExpression: any,
  fieldConfig: FieldConfig,
  model: any
): void {
  const itemsTableHead = fieldConfig?.jsonFieldSort;
  if (itemsTableHead) {
    model[itemsTableHead] = evalExpression;
  }
}

